import { Button, Flex, Space } from 'antd';
import _ from 'lodash-es';
import { useMemo } from 'react';
import intl from 'react-intl-universal';
import Evisit from '../../../libs/Evisit';

const EconsultConfirmmation = ({onNext, data, isMobileWebview, endWorkflow}) => {
    const submittedOn = new Date().toLocaleString();
    const displayVisitId = useMemo(() => {
        return Evisit.getDisplayVisitId(_.get(data, "visit.value"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            { <>
                  <p>{intl.get("e_consult_confirm").d("Your E-Consult is submitted successfully. You will receive a notification when there is a response. ")}</p>
                  <p>{intl.get("consult_id").d("Consult ID") }: {displayVisitId}</p>
                  <p>{intl.get("submitted_on").d("Submitted on")}: {submittedOn}</p>
              </>
              
            }
            <Flex justify={isMobileWebview ? "center" : "flex-end"} gap="small">
                <Button
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    onClick={() => {
                        // This is a hacky solution.
                        // Set the type to 0. So the page won't redirect to the visit detail page
                        _.set(data, "visit.value.type", 0);
                        // call the endWorkflow function to close the modal
                        endWorkflow();
                    }}
                >
                    Close
                </Button>
            </Flex>
        </Space>
    );
}

export default EconsultConfirmmation;